//INCLUDE VUE MODULE
import Vue from 'vue';
import axios from 'axios';

// INCLUDE DEFAULT ENV FILE
import { getPlatformConfig } from '@config/env';

//INCLUDE STORE
import { createStore } from './app/state/store'

import { helperFunctions } from './config/helper'

// CSS
// require('./sass/app.scss');

//INCLUDE LIBRARIES CONFIGURATION
require('./config/directives');

//INCLUDE LIBRARIES CONFIGURATION
require('./config/libraries');

//INCLUDE ELEMENTS CONFIGURATION
require('./config/elements');

//INCLUDE MAP CONFIG
require('./config/map');

//INCLUDE ROUTER
import { createRouter } from './app/router/routes';

//INCLUDE AXIOS CONFIGURATION
import { setAuthenticationConfig, setConfigAxios, setGoogleConfig } from './config/http';

//VALIDATORES
import { setCustomValidatorRules } from './config/validators';

// EVENT BUS
require('./config/event-bus');

import { isFunction, loadConfigurationModule } from './config/utils';

import { createI18n, setI18nLocales } from './config/i18n';

// BROADCASTING
import BroadcastingMixin from '@/app/shared/mixins/broadcasting/BroadcastingMixin'
import { GLOBAL, EVENTS } from '@/app/shared/utils/constants';

// ServiceWorker
// import '@/app/shared/utils/registerServiceWorker';

let isProduction = process.env.NODE_ENV == 'production';
Vue.config.devtools = !isProduction;
Vue.config.debug = !isProduction;
Vue.config.performance = !isProduction;
Vue.config.silent = isProduction;

const createVueApp = (config) => {
    try {
        let platformTitle = config.title || 'CityHub.pt';

        let store = createStore(config);
        let router = createRouter(config, store);
        setConfigAxios(config, store, router);
        setAuthenticationConfig();
        let configSettings = config?.settings ?? {};
        let googleSettings = configSettings?.google ?? null;
        setGoogleConfig(googleSettings, router, platformTitle, config.DEBUG);

        let app = new Vue({
            el: '#app',
            router,
            store,
            i18n: createI18n(config),
            mixins: [
                BroadcastingMixin
            ],
            data() {
                return {
                    loadApp: false,
                    forceLoadSettings: false,
                    platformTitle: platformTitle,
                }
            },
            created() {
                this.$eventBus.listen(GLOBAL.MODULE, `${EVENTS.SHOW_MESSAGE}`, this.showGlobalMessage);
                this.$eventBus.listen(GLOBAL.MODULE, `${EVENTS.SHOW_NOTIFICATION}`, this.showGlobalNotification);

                this.setWindowTitle(this.platformTitle);

                this.$env = config;
                this.$helper = helperFunctions(this);

                let locale = this.$i18n.locale;
                this.$store.dispatch('setLocale', {
                    code: `${locale}-${locale}`,
                    // language: {},
                    // localLanguage: language[code]}
                });
                setCustomValidatorRules(locale);
            },
            mounted() {
                window.addEventListener('resize', this.onResizeWindow);
            },
            unmounted() {
                window.removeEventListener('resize', this.onResizeWindow);
            },
            beforeDestroy() {
                this.$eventBus.remove(GLOBAL.MODULE, `${EVENTS.SHOW_MESSAGE}`, this.showGlobalMessage);
                this.$eventBus.remove(GLOBAL.MODULE, `${EVENTS.SHOW_NOTIFICATION}`, this.showGlobalNotification);
            },
            computed: {
                moduleCode() {
                    return this.$store.getters.moduleCode || null;
                },
                moduleName() {
                    return this.$store.getters.moduleName || '';
                },
                // module() {
                //     return this.moduleCode ? this.$store.getters.getModule(this.moduleCode) : {};
                // },
                windowTitle() {
                    let base = this.moduleName;
                    let metaTitle = this.$route.meta.title;
                    let title = this.$t(metaTitle ?
                                    (isFunction(metaTitle) ?
                                        metaTitle(this.$route) : metaTitle) : '');
                    title = !base || 0 === base.trim().length ?
                                title : (!title || 0 === title.trim().length ? base : `${base} | ${title}`);
                    return title;
                },
            },
            methods: {
                onResizeWindow: function(evt) {
                    let width = document.documentElement.clientWidth;
                    let height = document.documentElement.clientHeight;
                    this.$root.$emit('onResizeWindow', {
                        evt,
                        width,
                        height,
                    });
                },
                setFlagLoadSettings: function(flag) {
                    this.forceLoadSettings = flag;
                },
                checkModuleExist: function(code) {
                    return this.$root.$modules.find( m => {
                        return m.code == code;
                    })
                },
                loadModuleSettings: function(module, subModule, aliasCode, applicationCode) {
                    let forceCallModule = this.forceLoadSettings;
                    let _module = module.toLowerCase();
                    if((_module == this.moduleCode) && !forceCallModule){
                        return
                    }

                    this.$store.dispatch(`setConfig`, this.$env);
                    setI18nLocales(this.$i18n, _module, this.$store, this.$env);
                    this.setFlagLoadSettings(false);
                    let config = this.$root.$env;

                    this.$store.dispatch(`setCustomSettings`, {
                        'module': _module,
                        'themeConfig': config.THEME,
                        'config': config
                    }).then(() => {
                        // ESTA LOGICA DEVIA SER MELHORADA
                        let _codeAPI = aliasCode || this.$store.getters[`${_module}/getCodeApiModule`] || _module;
                        let _backoffice = '';
                        if(_module.endsWith(CITYHUB_MANAGE_SUFFIX)) {
                            _backoffice = CITYHUB_MANAGE_SUFFIX;
                        }else if(_module.endsWith('central')) {
                            _backoffice = 'central';
                        }
                        let _applicationCode = applicationCode ? applicationCode.replace(new RegExp(`(${CITYHUB_MANAGE_SUFFIX}|central)$`), '') : null;
                        let url = [
                            _codeAPI,
                            subModule ?? (_applicationCode && _applicationCode!=_codeAPI ? _applicationCode : null),
                            'front',
                            _backoffice,
                        ].filter(item => !!item)
                        .join('/');

                        this.$http.get(`/${url}`)
                        .then(res => {
                            let _data = {...res.data.data, 'route': this.$route};
                            _data.code = _data.code.replace(/\..*$/,'');
                            _data.applicationCode = _data.code;

                            this.$store.dispatch(`setModule`, _data)
                            .then(() => {
                                let urlConfig = config.APP_URL;
                                let title = this.windowTitle;//this.$store.getters.moduleName;
                                let description = this.$store.getters.moduleDescription;
                                this.appendMetaTag('title', title);
                                this.appendMetaTag('description', description);
                                this.appendMetaTag('keywords', this.$store.getters.moduleKeywords);
                                this.appendMetaTag('application-name', title);
                                this.appendMetaTag('theme-color', this.$store.getters.moduleThemeColor);
                                this.appendMetaTag('msapplication-TileColor', this.$store.getters.moduleThemeColor);

                                // Social Meta Tags
                                this.appendMetaTag('apple-mobile-web-app-title', title);
                                this.appendMetaTag('twitter:title', title);
                                this.appendMetaTag('twitter:description', description);
                                this.appendMetaTag('twitter:site', this.moduleName);
                                this.appendMetaTag('og:title', title, true);
                                this.appendMetaTag('og:description', description, true);
                                this.appendMetaTag('og:url', urlConfig, true);
                                this.appendMetaTag('og:site_name', this.moduleName, true);

                                this.appendLinkTag(urlConfig, 'pt-pt');
                                // this.appendLinkTag(urlConfig, 'en');
                            })

                        })
                        .catch(error => {
                            let route = error?.response?.status == 503 ? 'portal.maintenance' : 'portal.notfound';
                            this.$router.push({name: route});
                        });
                    })

                },
                getDefinitionModule: function(info) {
                    if(typeof this.$store.state.page.definitions != 'undefined' && typeof this.$store.state.page.definitions[info] != 'undefined')
                    {
                        return this.$store.state.page.definitions[info];
                    }
                    else
                    {
                        return null;
                    }
                },
                fnHasError: function(item,app) {
                    return (app.fields && app.fields[item] &&
                            app.fields[item].dirty &&
                            !app.fields[item].valid) || (app.errors.has(item))
                },
                setWindowTitle(title) {
                    document.title = title;
                },
                appendMetaTag(name, content, isProperty=false) {
                    let tag = document.querySelector(isProperty ? `meta[property="${name}"]` : `meta[name="${name}"]`);
                    if(tag) {
                        // tag.remove();
                        tag.setAttribute("content", content);
                    }else{
                        tag = document.createElement("meta");
                        if(isProperty) {
                            tag.setAttribute("property", name);
                        }else{
                            tag.setAttribute("name", name);
                        }
                        tag.setAttribute("content", content);
                        document.head.appendChild(tag);
                    }
                },
                appendLinkTag(href, hreflang, rel='alternate') {
                    let link = document.querySelector(`link[hreflang="${hreflang}"]`);
                    if(link) {
                        link.remove();
                    }
                    let e = document.createElement("link");
                    e.setAttribute("rel", rel);
                    e.setAttribute("href", href);
                    e.setAttribute("hreflang", hreflang);
                    document.head.appendChild(e);
                },
                registerModuleStore(moduleCode) {
                    if(moduleCode && !this.$store.hasModule(moduleCode)){
                        let config = loadConfigurationModule(this.$store, moduleCode);
                        this.$store.registerModule(moduleCode, config.state || {} );
                    }
                },
                unregisterModuleStore(moduleCode) {
                    if(moduleCode && this.$store.hasModule(moduleCode)){
                        this.$store.unregisterModule(moduleCode)
                    }
                },
                showGlobalMessage(data) {
                    this._showMessage(data);
                },
                showGlobalNotification(data) {
                    this._showMessage(data);
                },
                _showMessage(data, callbackClose = ()=>{}, timeout = 6000) {
                    this.$helper.messages.showToast(
                        this.$t(data?.message),
                        this.$t(data?.title ?? 'home.title'),
                        (data?.code >= 200 && data?.code <= 299) ? 'success' : 'error',
                        callbackClose,
                        timeout,
                        false
                    );
                },
            },
            watch: {
                windowTitle (value, oldValue) {
                    this.setWindowTitle(value);
                },
                moduleCode: {
                    immediate: true,
                    handler(value, oldValue){
                        if(value != oldValue) {
                            this.$eventBus.publish(
                                GLOBAL.MODULE,
                                EVENTS.MODULE_LOADED,
                                {
                                    code: value
                                }
                            );
                        }
                    }
                },
            },
        });

        store.$helper = app.$helper;

        // if(navigator.userAgent.match(/Android/i)){
        //     console.log('Android')
        //     // Set a timeout...
        //     setTimeout(function(){
        //        // Hide the address bar!
        //        window.scrollTo(0, 1);
        //     }, 0);
        //  }

        return app;
    } catch (err) {
        console.error(err);
    }
};

const initApplication = async () => {
    // console.log('process.env.NODE_ENV :>> ', process.env.NODE_ENV);
    const env = getPlatformConfig(CITYHUB_PLATFORM, process.env.NODE_ENV, process.env.MODE_BUILD);
    return await getPlatformConfigFromAPI(env.API_URL)
    .then((config) => {
        //CREATE THE APP
        config = {...config, ...env};
        let app = createVueApp(config);
        return app;
    }).catch(error => {
        if(error?.response?.status == 503) {
            const config = {...env};
            const app = createVueApp(config);
            return app;
        }
    });
};

const getPlatformConfigFromAPI = async (url) => {
    return await axios.get(`${url}/platform/config`)
    .then(res => {
        return res.data.data || res.data || {};
    });
};
initApplication();

let timeoutId = null;
const setDocumentHeight = () => {
    clearTimeout(timeoutId); // avoid execution of previous timeouts
    timeoutId = setTimeout(() => {
        const doc = document.documentElement;
        // First we get the viewport height and multiply it by 1% to get a value for a vh unit
        let vh = window.innerHeight * 0.01;
        doc.style.setProperty('--doc-height', `${vh}px`)
    }, 200);
};
if(window.attachEvent) {
    window.attachEvent('onresize', setDocumentHeight);
    window.attachEvent('orientationchange', setDocumentHeight);
}
else if(window.addEventListener) {
    window.addEventListener('resize', setDocumentHeight, true);
    window.addEventListener('orientationchange', setDocumentHeight, true);
}
setDocumentHeight();

window.addEventListener("load", function() {
    setTimeout(function() {
        let scrollPos = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollPos < 1) {
            window.scrollTo(0,1);
        }
    }, 0);
});

/*
  * Normalized hide address bar for iOS & Android
  * (c) Scott Jehl, scottjehl.com
  * MIT License
*/
// (function( win ){
//     var doc = win.document;

//     // If there's a hash, or addEventListener is undefined, stop here
//     if( !location.hash && win.addEventListener ){

//         //scroll to 1
//         window.scrollTo( 0, 1 );
//         var scrollTop = 1,
//             getScrollTop = function(){
//                 return win.pageYOffset || doc.compatMode === "CSS1Compat" && doc.documentElement.scrollTop || doc.body.scrollTop || 0;
//             },

//             //reset to 0 on bodyready, if needed
//             bodycheck = setInterval(function(){
//                 if( doc.body ){
//                     clearInterval( bodycheck );
//                     scrollTop = getScrollTop();
//                     win.scrollTo( 0, scrollTop === 1 ? 0 : 1 );
//                 }
//             }, 15 );

//         win.addEventListener( "load", function(){
//             setTimeout(function(){
//                 //at load, if user hasn't scrolled more than 20 or so...
//                 if( getScrollTop() < 20 ){
//                     //reset to hide addr bar at onload
//                     win.scrollTo( 0, scrollTop === 1 ? 0 : 1 );
//                 }
//             }, 0);
//         } );
//     }
// })( window );